/* BECK 777 PDP — Phase 1: size picker (D6 truthful pricing) + gallery switching. No globals; scoped to [data-beck-hero].
   Line rollout: guarded multi-color support — single-color products unaffected (no [data-beck-cswatch] present). */
(function () {
  'use strict';
  var hero = document.querySelector('[data-beck-hero]');
  if (!hero) return;

  /* Size chips — variant picker */
  var priceEl = hero.querySelector('[data-beck-price]');
  var idInput = hero.querySelector('[data-beck-id]');
  var sizeLabel = hero.querySelector('[data-beck-sizelabel]');
  var cta = hero.querySelector('[data-beck-cta]');
  var chips = hero.querySelectorAll('[data-beck-chip]');
  var lastSize = { v: '' };
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (chip.disabled) return;
      chips.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
      chip.classList.add('is-selected');
      chip.setAttribute('aria-checked', 'true');
      lastSize.v = chip.getAttribute('data-size') || chip.textContent.trim();
      if (idInput) idInput.value = chip.getAttribute('data-variant-id');
      if (priceEl && chip.getAttribute('data-price')) priceEl.textContent = chip.getAttribute('data-price');
      if (sizeLabel) sizeLabel.textContent = 'Size — ' + chip.textContent.trim();
      if (cta) cta.disabled = false;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', chip.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* no-op */ }
    });
  });

  /* Multi-color (guarded) */
  var cswatches = hero.querySelectorAll('[data-beck-cswatch]');
  if (cswatches.length) {
    var groups = Array.prototype.slice.call(hero.querySelectorAll('[data-color-group]'));
    var clabel = hero.querySelector('[data-beck-colorlabel]');
    cswatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var val = sw.getAttribute('data-color');
        cswatches.forEach(function (s) { var on = s === sw; s.classList.toggle('is-selected', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        groups.forEach(function (g) { g.hidden = g.getAttribute('data-color-group') !== val; });
        if (clabel) clabel.textContent = val;
        var g = null;
        for (var i = 0; i < groups.length; i++) { if (!groups[i].hidden) { g = groups[i]; break; } }
        if (!g) return;
        var target = lastSize.v ? g.querySelector('[data-beck-chip][data-size="' + lastSize.v + '"]:not([disabled])') : null;
        if (!target) target = g.querySelector('[data-beck-chip].is-selected:not([disabled])') || g.querySelector('[data-beck-chip]:not([disabled])');
        if (target) target.click();
      });
    });
  }

  /* Gallery — thumbnail switching, 200ms crossfade */
  var heroImg = hero.querySelector('[data-beck-heroimg]');
  var thumbs = hero.querySelectorAll('[data-beck-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (!heroImg || t.classList.contains('is-active')) return;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var src = t.getAttribute('data-src');
      var full = t.getAttribute('data-full');
      heroImg.style.opacity = '0';
      window.setTimeout(function () {
        heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
        heroImg.srcset = src + ' 1017w, ' + full + ' 1356w';
        heroImg.src = src;
      }, 100);
    });
  });
})();
